<template>
    <div class="job-details-wrapper col-md-12">
        <transition name="vue-table-loader">
	        <div class="vue-table-loader" v-if="isLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
	    </transition>
        <div class="card panel panel-default actions">
            <div class="card-block">
                <div class="header-block clearfix">
                    <h3 class="pull-left">Job: {{jobId}} - {{jobs.name}}</h3>
                </div>
            </div>
        </div>
        <div class="top-table" v-show="messages.length > 1">
            <list-filter placeholder="Search Messages" :target-list="typeFilteredMessages" :search-config="searchConfig" @results="handleSearchUpdate"></list-filter>
            <select v-model="filterSelect" class="form-control">
                <option disabled value="">Type Filter</option>
                <option value="">No Filter</option>
                <option :value="type" v-for="(type, idx) in availableTypes" :key="idx">Filter Type: {{type}}</option>
            </select>
        </div>

        <div class="top-table ml-2" v-if="messages.length > 1">
            {{ displayMessage }}
        </div>
        <div class="table-wrapper">
            <div class="row job-table-row-header">
                <div class="col-md-8 job-table-header-cell">Message</div>
                <div class="col-md-2 job-table-header-cell">Type</div>
                <div class="col-md-2 job-table-header-cell">Created At</div>
            </div>
            <div class="row job-table-row" v-for="item in paginatedMessages" :key="item.id">
                <div class="col-md-8 job-table-cell text-monospace" v-html="item.message"></div>
                <div class="col-md-2 job-table-cell text-uppercase">{{ item.type }}</div>
                <div class="col-md-2 job-table-cell">{{ formatTime(item.created_at) }}</div>
            </div>
        </div>

        <div class="bottom-table">
            <button v-if="hasEventCloseJob"  type="button" class="btn btn-primary ml-2" @click="$emit('close-details')">Close Job Details</button>
            <button v-if="!hasEventCloseJob"  type="button" class="btn btn-primary ml-2" @click="jobsListRedirect">Back to the Jobs List</button>
            <list-pagination :mappings-per-page="21" :target-list="filteredMessages" @results="handlePaginationUpdate"></list-pagination>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import ListFilter from '../generic/list-filter.vue';
import ListPagination from '../generic/list-pagination.vue';

export default {
    name: 'job-details',
    components: {
        'list-filter': ListFilter,
        'list-pagination': ListPagination
    },
    props: {
        jobId: Number
    },
    data() {
        return {
            isLoading: true,
            jobs: {},
            messages: [],
            filterSelect: '',
            filteredMessages: [],
            paginatedMessages: [],
            searchConfig: {
                targetlistType: 'object',
                targetKeys: ['message', 'type'],
            }
        }
    },
    mounted() {
        this.isLoading = true;
        axios.get('/jobs/' + this.jobId)
        .then((response) => {
            this.jobs = response.data.jobs;
            this.messages = response.data.jobs.messages;
            this.searchConfig.targetList = this.messages;
            this.isLoading = false;
        })
        .catch((err) => {
            console.log('error');
            console.log(err);
            this.isLoading = false;
        })
    },
    computed: {
        typeFilteredMessages() {
            return this.messages.filter((el) => {
                if (this.filterSelect == '') {
                    return true;
                }
                return el.type.toLowerCase() == this.filterSelect.toLowerCase();
            })
        },
        displayMessage() {
            return `${this.filteredMessages.length} messages`;
        },
        availableTypes() {
            let types = [];
            this.messages.forEach(element => {
                if (!types.includes(element.type.toUpperCase())) {
                    types.push(element.type.toUpperCase());
                }
            });
            return types;
        },
        hasEventCloseJob() {
            return this.$listeners && this.$listeners['close-details'];
        }
    },
    methods: {
        handleSearchUpdate(fMsg) {
            this.filteredMessages = fMsg;
        },
        handlePaginationUpdate(pMsg) {
            this.paginatedMessages = pMsg;
        },
        formatTime(tstamp) {
            return moment(tstamp).format('MMMM Do YYYY, h:mm:ss a');
        },
        jobsListRedirect() {
            window.location.href = route('jobs.index');
        }
    }
}
</script>

<style lang="scss">

div.job-details-wrapper {

    .table-wrapper {
        padding: 15px 0;
    }


    div.job-table-row {
        padding: 5px 0;
        margin: 0;
    }

    div.job-table-row:nth-child(odd) {
        background-color: #f0f2ff;
    }

    div.job-table-row-header {
        padding: 10px 0 0 0;
        padding: 0;
        margin: 0;
    }

    .job-table-row-header {
        color: #3f759e;
        padding-top: 15px;
    }

    .top-table {
        display: flex;
        padding: 5px;
        color: silver;
    }

    .bottom-table {
        display: flex;
        justify-content: space-between;
    }

    .form-control {
        background-color: white;
        max-width: 200px;
        margin-left: 3px;
    }

}

</style>
